import { render, staticRenderFns } from "./ConsultaRelatoriosLRFCI.vue?vue&type=template&id=bf0b910e"
import script from "./ConsultaRelatoriosLRFCI.vue?vue&type=script&lang=ts"
export * from "./ConsultaRelatoriosLRFCI.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports